import { useState, useEffect } from 'react';

interface UseScrollNavigationReturn {
  activeSection: string;
  scrollToSection: (sectionId: string) => void;
}

export const useScrollNavigation = (sections: string[] = []): UseScrollNavigationReturn => {
  const [activeSection, setActiveSection] = useState<string>('');

  useEffect(() => {
    const handleScroll = (): void => {
      const scrollPosition = window.scrollY + 100;

      // Nothing is active while the hero (above the first section) is in view.
      let current = '';
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element && element.offsetTop <= scrollPosition &&
            element.offsetTop + element.offsetHeight > scrollPosition) {
          current = section;
          break;
        }
      }
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);

  const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return { activeSection, scrollToSection };
};